import { PropsWithChildren, ReactElement } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { WagmiProvider } from 'wagmi';

import { config } from 'modules/auth/appKit';
import { useWatchReown } from 'modules/auth/hooks/useWatchReown';

const queryClient = new QueryClient();

export function ReownConnectionProvider({
  children,
}: PropsWithChildren): ReactElement {
  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <ReownWatcher />

        {children}
      </QueryClientProvider>
    </WagmiProvider>
  );
}

function ReownWatcher(): null {
  useWatchReown();

  return null;
}
